import { Collapse } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type OptionInteractiveContentProps = {
  isOpen: boolean;
  children: ReactNode;
};

export const OptionInteractiveContent = ({
  isOpen,
  children,
}: OptionInteractiveContentProps) => {
  return (
    <Collapse in={isOpen} animateOpacity>
      <div
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
      >
        {children}
      </div>
    </Collapse>
  );
};
